import React, { useState, useRef } from "react";
import { GrClose } from "react-icons/gr";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const ImageModal = ({ product, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(1); // Start from image[1]
  const startX = useRef(null);

  const images = product.images;

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const handleMouseDown = (e) => {
    startX.current = e.clientX;
  };

  const handleMouseUp = (e) => {
    const endX = e.clientX;
    if (startX.current !== null) {
      const diff = startX.current - endX;
      if (diff > 50) handleNext(); // Swipe left
      else if (diff < -50) handlePrev(); // Swipe right
    }
    startX.current = null;
  };

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    if (startX.current !== null) {
      const diff = startX.current - endX;
      if (diff > 50) handleNext();
      else if (diff < -50) handlePrev();
    }
    startX.current = null;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-5">
      <div className="bg-white max-w-2xl p-3 h-[80vh] w-full rounded-md shadow-md relative flex justify-center items-center">
        {/* Image with swipe detection */}
        <img
          src={images[currentIndex]}
          alt=""
          className="w-full h-full object-contain"
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        />

        {/* Close button */}
        <GrClose
          onClick={onClose}
          className="absolute bg-white text-red-600 -top-2 -right-2 w-6 h-6 rounded-full p-1 shadow cursor-pointer"
        />

        {/* Prev Button */}
        <button
          onClick={handlePrev}
          className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow hover:bg-gray-200"
        >
          <FaArrowLeft />
        </button>

        {/* Next Button */}
        <button
          onClick={handleNext}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow hover:bg-gray-200"
        >
          <FaArrowRight />
        </button>
      </div>
    </div>
  );
};

export default ImageModal;
